import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import styles from "components/payment/PaymentRowWarningIcon.module.scss";
import { Message } from "shared/components/Message";
import { FormatXMLElementFn, PrimitiveType } from "intl-messageformat";
import React, { FC, useState } from "react";
import { MessageDescriptor } from "react-intl";
import Popover from "reactstrap/lib/Popover";
import PopoverBody from "reactstrap/lib/PopoverBody";
import PopoverHeader from "reactstrap/lib/PopoverHeader";

interface IProps {
    id: string;
    colour: "warning" | "danger";
    heading?: MessageDescriptor;
    message: MessageDescriptor;
    values?: { [key: string]: string | PrimitiveType | React.ReactElement | FormatXMLElementFn };
}

export const PaymentRowWarningIcon: FC<IProps> = ({
    id,
    colour,
    heading,
    message,
    values,
}) => {
    const [displayPopover, setDisplayPopover] = useState(false);

    const triggerId = `warning-trigger-${id}`;
    const contentId = `warning-content-${id}`;
    const headerId = `warning-header-${id}`;
    const bodyId = `warning-body-${id}`;

    const ariaLabelledBy = heading ? `${headerId} ${bodyId}` : bodyId;

    return (
        <>
            <button
                id={triggerId}
                type="button"
                className="btn btn-link p-0 border-0 ml-2 bg-transparent align-baseline"
                onClick={togglePopover}
                aria-labelledby={ariaLabelledBy}
                aria-expanded={displayPopover}
                aria-controls={contentId}
            >
                <FontAwesomeIcon
                    icon={faExclamationTriangle}
                    className={classNames(`text-${colour}`, styles.warningIcon)}
                    aria-hidden="true"
                />
            </button>

            <Popover
                id={contentId}
                placement="bottom"
                isOpen={displayPopover}
                toggle={togglePopover}
                target={triggerId}
            >
                {heading && (
                    <PopoverHeader id={headerId}>
                        <Message message={heading} />
                    </PopoverHeader>
                )}
                <PopoverBody id={bodyId}>
                    <Message message={message} values={values} />
                </PopoverBody>
            </Popover>
        </>
    );

    function togglePopover() {
        setDisplayPopover(!displayPopover);
    }
};
